var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNarrowViewSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_689_33844)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 0H4C1.79086 0 0 1.79086 0 4V40C0 42.2091 1.79086 44 4 44H40C42.2091 44 44 42.2091 44 40V4C44 1.79086 42.2091 0 40 0Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.75 19.75H15C13.895 19.75 13 18.855 13 17.75V15C13 13.895 13.895 13 15 13H17.75C18.855 13 19.75 13.895 19.75 15V17.75C19.75 18.855 18.855 19.75 17.75 19.75Z",
    fill: "#21242B",
    stroke: "#21242B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29 19.75H26.25C25.145 19.75 24.25 18.855 24.25 17.75V15C24.25 13.895 25.145 13 26.25 13H29C30.105 13 31 13.895 31 15V17.75C31 18.855 30.105 19.75 29 19.75Z",
    fill: "#21242B",
    stroke: "#21242B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.75 31H15C13.895 31 13 30.105 13 29V26.25C13 25.145 13.895 24.25 15 24.25H17.75C18.855 24.25 19.75 25.145 19.75 26.25V29C19.75 30.105 18.855 31 17.75 31Z",
    fill: "#21242B",
    stroke: "#21242B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29 31H26.25C25.145 31 24.25 30.105 24.25 29V26.25C24.25 25.145 25.145 24.25 26.25 24.25H29C30.105 24.25 31 25.145 31 26.25V29C31 30.105 30.105 31 29 31Z",
    fill: "#21242B",
    stroke: "#21242B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_689_33844"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNarrowViewSelected);
export default __webpack_public_path__ + "static/media/narrow-view-selected.4d2151032c92aa44547df7d8fa984498.svg";
export { ForwardRef as ReactComponent };